export enum SubjectType {
	BusinessEntity = 1,
	LegalEntity = 2,
}
